<template>
  <div class="btn btn-default">
    <PickerDatetime
      v-model="dateStart"
      :as-input="false"
      :format="format"
      :placeholder="$t('Select here')"
      class="m-r-5"
      name="dateFrom"
    >
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <HoverShowEditIcon placeholder-icon="zmdi-calendar">
        {{
          dateRangeCopy.isUnsafe && dateRangeCopy.start === '' ? placeholder : dateRangeCopy.start
        }}
      </HoverShowEditIcon>
    </PickerDatetime>
    -
    <PickerDatetime
      v-model="dateEnd"
      :as-input="false"
      :format="format"
      :placeholder="$t('Select here')"
      class="m-l-5"
      name="dateTo"
    >
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <HoverShowEditIcon placeholder-icon="zmdi-calendar">
        {{ dateRangeCopy.isUnsafe && dateRangeCopy.end === '' ? placeholder : dateRangeCopy.end }}
      </HoverShowEditIcon>
    </PickerDatetime>
  </div>
</template>

<script>
import PickerDatetime from '@/components/PickerDatetime.vue'
import DateRange from '@/vue-prop-types/DateRange'

export default {
  components: { PickerDatetime },
  props: {
    format: { type: String, default: 'YYYY-MM' },
    dateRange: {
      type: DateRange,
      required: false,
      default() {
        return new DateRange({ format: 'YYYY-MM' })
      },
    },
  },
  data() {
    return {
      placeholder: this.$t('Select here'),
    }
  },
  computed: {
    // These computed props ensures proper propagation of parent components changes
    dateRangeCopy() {
      return DateRange.copy(this.dateRange)
    },
    dateStart: {
      get() {
        return this.dateRangeCopy.start
      },
      set(val) {
        this.dateRangeCopy.start = val
        this.$emit('update:dateRange', this.dateRangeCopy)
      },
    },
    dateEnd: {
      get() {
        return this.dateRangeCopy.end
      },
      set(val) {
        this.dateRangeCopy.end = val
        this.$emit('update:dateRange', this.dateRangeCopy)
      },
    },
  },
}
</script>
